<template>
  <div id="scroll" class="lower-page property-list bg-white">
    <navbar />
    <div class="lower-mv" :style="lowermv">
      <h2>{{ $t('都道府県から売買物件を探す') }}</h2>
    </div>
    <section class="wrapper">
      <div class="search-tab">
        <router-link :to="{ name: 'Client Property List', params: {lang: language}}">{{ $t('一覧から探す') }}</router-link>
        <router-link :to="{ name: 'Client Property Map', params: {lang: language}}" class="current">{{ $t('都道府県から探す') }}</router-link>
      </div>
      <div id="map-wrap">
        <div class="map-wrapper">
          <div class="map-area">
            <div v-for="(value, key) in areas" :key="key" :class="[key, 'area-wrap']">
              <ul v-if="Array.isArray(value)">
                <li v-for="prefecture in value" :key="prefecture">
                  <router-link :to="{ name: 'Client Prefecture Property List', params: {lang: language, prefecture: prefecture} }">
                    <div :data-label="prefecture" :class="getFukidashiClass(prefecture)">
                      <span v-on:mouseover="updateActivePrefecture(prefecture)" v-on:mouseout="updateActivePrefecture(null)">
                        <button>{{$t(prefecture[0].toUpperCase()+prefecture.slice(1))}}</button>
                      </span>
                      <div class="box" :style="getMapBoxStyle(prefecture)">
                        <p class="ttl">{{$t(prefecture[0].toUpperCase()+prefecture.slice(1))}}</p>
                        <p><img :src="getPrefectureImage(prefecture)"></p>
                      </div>
                    </div>
                  </router-link>
                </li>
              </ul>
              <ul v-else v-for="(prefectures, block) in value" :key="block" :class="block">
                <li v-for="prefecture in prefectures" :key="prefecture">
                  <router-link :to="{ name: 'Client Prefecture Property List', params: {lang: language, prefecture: prefecture} }">
                    <div :data-label="prefecture" :class="getFukidashiClass(prefecture)">
                      <span v-on:mouseover="updateActivePrefecture(prefecture)" v-on:mouseout="updateActivePrefecture(null)">
                        <button>{{$t(prefecture[0].toUpperCase()+prefecture.slice(1))}}</button>
                      </span>
                      <div class="box" :style="getMapBoxStyle(prefecture)">
                        <p class="ttl">{{$t(prefecture[0].toUpperCase()+prefecture.slice(1))}}</p>
                        <p><img :src="getPrefectureImage(prefecture)"></p>
                      </div>
                    </div>
                  </router-link>
                </li>
              </ul>
            </div>
            <!-- 地図エリア -->
            <div class="map">
              <div class="img-map">
                <img src="@/assets/img/client/property-map/map.jpg" usemap="#ImageMap" alt="日本地図" class="map_link" />
                <div class="layer-disabled" :style="getDisabledLayerStyle()"></div>
                <div class="layer-hover" :style="getHoveredLayerStyle()"></div>
              </div>

              <div class="num-wrap">
                <p v-for="(data, prefecture) in propertyMap" :key="prefecture" :class="`num-${prefecture}`"
                  :style="{ opacity: data.property_count == 0 && activePrefecture != prefecture ? 0 : 1 }">{{ data.property_count }}</p>
              </div>

              <map name="ImageMap">
                <area v-for="data in imageMap" :key="data.prefecture"
                  :shape="data.shape" :coords="data.coords" :alt="`area_${data.prefecture}`"
                  :class="getAreaClass(data.prefecture)"
                  :href="$router.resolve({ name: 'Client Prefecture Property List', params: {lang: language, prefecture: data.prefecture} }).href"
                  @mousemove="hoverMapArea($event, data.prefecture)"
                  @mouseout="updateActivePrefecture(null)" />
              </map>
            </div>
            <!-- //地図エリア -->
          </div>
        </div>
      </div>

      <!-- 地図吹き出しエリア -->
      <div class="mapon">
        <div v-for="(data, prefecture) in propertyMap" class="p_box" :key="prefecture" v-bind:id="'p_' + prefecture" :style="getMapAreaBoxStyle(prefecture)">
          <p class="ttl">{{ data.label }}</p>
          <p><img v-bind:src="data.image" /></p>
        </div>
      </div>
    </section>
    <footerClient />
  </div>
</template>
<script>
import navbar from '@/components/client/navbar'
import footerClient from '@/components/client/footerClient'
import { mapState, mapActions } from 'vuex'

export default {
  data () {
    return {
      language: this.$route.params.lang,
      lowermv: {
        background: `url(${require('@/assets/img/client/lower_mvbg.jpg')}) center / cover`
      },
      activePrefecture: null,
      mapHoverCursor: null,
      areas: {
        area1: [
          'hokkaido'
        ],
        area2: [
          'aomori',
          'iwate',
          'akita',
          'miyagi',
          'yamagata',
          'fukushima'
        ],
        area3: [
          'tokyo',
          'saitama',
          'kanagawa',
          'chiba',
          'ibaraki',
          'tochigi',
          'gunma'
        ],
        area4: {
          'block-1': [
            'niigata',
            'toyama',
            'ishikawa',
            'nagano',
            'yamanashi'
          ]
        },
        area5: [
          'aichi',
          'shizuoka',
          'gifu',
          'mie'
        ],
        area6: {
          'block-1': [
            'osaka',
            'hyogo',
            'kyoto',
            'shiga',
            'nara',
            'wakayama'
          ],
          'block-2': [
            'okayama',
            'hiroshima',
            'tottori',
            'shimane',
            'yamaguchi'
          ]
        },
        area7: [
          'ehime',
          'kagawa',
          'kochi',
          'tokushima'
        ],
        area8: [
          'fukuoka',
          'saga',
          'nagasaki',
          'oita',
          'kumamoto',
          'miyazaki',
          'kagoshima'
        ],
        area9: [
          'okinawa'
        ]
      },
      imageMap: [
        { prefecture: 'hokkaido', shape: 'poly', coords: '420,0,419,74,395,92,395,113,427,113,429,99,447,98,475,119,509,99,538,99,537,54,515,55,450,1,419,1,445,23' },
        { prefecture: 'aomori', shape: 'poly', coords: '396,138,396,169,477,169,475,160,454,146,454,125,440,126,440,148,416,148,415,138,396,138,505,119' },
        { prefecture: 'iwate', shape: 'poly', coords: '435,172,435,208,472,208,478,198,477,170,435,170,431,145' },
        { prefecture: 'miyagi', shape: 'poly', coords: '434,210,434,251,471,250,468,210,434,210,438,122' },
        { prefecture: 'akita', shape: 'poly', coords: '395,171,396,210,433,208,434,170,395,170,391,168' },
        { prefecture: 'yamagata', shape: 'poly', coords: '396,211,396,234,404,234,402,252,434,252,433,211,395,211,476,160' },
        { prefecture: 'fukushima', shape: 'poly', coords: '403,256,403,285,469,286,469,255,403,255,470,172' },
        { prefecture: 'ibaraki', shape: 'poly', coords: '443,287,442,329,476,328,470,322,470,287,443,287,444,314' },
        { prefecture: 'tochigi', shape: 'poly', coords: '409,288,409,319,440,320,439,288,409,288,418,278' },
        { prefecture: 'gunma', shape: 'poly', coords: '377,287,377,318,407,318,407,287,377,287,385,292' },
        { prefecture: 'saitama', shape: 'poly', coords: '379,322,378,337,440,337,440,322,379,321,383,321' },
        { prefecture: 'chiba', shape: 'poly', coords: '442,331,442,357,451,357,452,382,477,382,476,332,442,331,484,288' },
        { prefecture: 'tokyo', shape: 'poly', coords: '397,341,396,357,439,357,440,340,396,340,446,303' },
        { prefecture: 'kanagawa', shape: 'poly', coords: '395,360,395,381,433,381,433,360,395,360,465,309' },
        { prefecture: 'niigata', shape: 'poly', coords: '396,237,402,237,401,283,351,284,350,272,396,237,391,237' },
        { prefecture: 'toyama', shape: 'poly', coords: '347,275,320,292,307,292,307,309,346,308,347,275,488,270' },
        { prefecture: 'ishikawa', shape: 'poly', coords: '287,277,305,277,304,315,269,315,287,302,287,277,320,242' },
        { prefecture: 'fukui', shape: 'poly', coords: '266,318,266,332,250,333,250,340,306,339,305,318,266,318,282,276' },
        { prefecture: 'yamanashi', shape: 'poly', coords: '372,340,370,371,393,370,393,339,371,338,390,341' },
        { prefecture: 'nagano', shape: 'poly', coords: '349,287,375,287,374,336,369,337,368,369,337,370,336,311,349,311,349,287,363,320' },
        { prefecture: 'gifu', shape: 'poly', coords: '307,312,334,311,334,371,303,371,303,342,307,342,307,312,323,326' },
        { prefecture: 'shizuoka', shape: 'poly', coords: '347,373,347,399,367,401,391,384,391,399,401,400,402,382,392,382,392,373,347,373,373,412' },
        { prefecture: 'aichi', shape: 'poly', coords: '303,372,303,385,310,384,311,400,345,400,345,373,303,373,525,458' },
        { prefecture: 'mie', shape: 'poly', coords: '277,372,277,431,294,430,295,385,301,383,300,372,277,372,277,372' },
        { prefecture: 'shiga', shape: 'rect', coords: '276,339,302,371' },
        { prefecture: 'kyoto', shape: 'poly', coords: '226,332,226,371,275,371,274,341,247,340,247,331,226,331,267,339' },
        { prefecture: 'osaka', shape: 'poly', coords: '227,372,227,381,235,379,236,402,253,402,253,373,227,373,237,379' },
        { prefecture: 'hyogo', shape: 'rect', coords: '193,330,226,381' },
        { prefecture: 'nara', shape: 'rect', coords: '254,372,277,415' },
        { prefecture: 'wakayama', shape: 'poly', coords: '235,405,252,404,253,416,274,416,275,433,235,432,236,404,466,380' },
        { prefecture: 'tottori', shape: 'rect', coords: '158,329,192,355' },
        { prefecture: 'shimane', shape: 'rect', coords: '125,330,159,355' },
        { prefecture: 'okayama', shape: 'rect', coords: '158,356,191,380' },
        { prefecture: 'hiroshima', shape: 'rect', coords: '125,356,159,380' },
        { prefecture: 'yamaguchi', shape: 'poly', coords: '124,331,97,350,96,381,124,380,124,331,198,303' },
        { prefecture: 'tokushima', shape: 'poly', coords: '167,416,167,432,209,440,208,416,167,415,500,412' },
        { prefecture: 'kagawa', shape: 'rect', coords: '168,398,211,413' },
        { prefecture: 'ehime', shape: 'poly', coords: '107,412,107,433,164,433,165,408,142,408,143,399,107,413,119,408' },
        { prefecture: 'kochi', shape: 'poly', coords: '108,433,106,457,145,456,156,446,179,445,187,456,207,455,207,441,166,434,107,433,123,444' },
        { prefecture: 'fukuoka', shape: 'poly', coords: '39,369,84,370,84,379,60,379,60,406,34,407,33,401,39,401,39,370,70,357' },
        { prefecture: 'saga', shape: 'rect', coords: '19,368,37,399' },
        { prefecture: 'nagasaki', shape: 'rect', coords: '1,367,18,411' },
        { prefecture: 'kumamoto', shape: 'poly', coords: '34,410,34,436,24,443,24,448,62,448,62,410,34,410,348,334' },
        { prefecture: 'oita', shape: 'rect', coords: '63,379,86,411' },
        { prefecture: 'miyazaki', shape: 'poly', coords: '62,415,62,455,80,454,80,425,85,418,84,415,62,415,62,415' },
        { prefecture: 'kagoshima', shape: 'poly', coords: '23,449,23,476,39,476,38,466,59,465,59,483,63,482,80,468,80,456,60,457,60,449,23,449,23,449' },
        { prefecture: 'okinawa', shape: 'rect', coords: '34,280,55,318' }
      ]
    }
  },
  created () {
    this.loadPropertyMap({ language: this.language, type: 'business' })
  },
  computed: {
    ...mapState('propertyClient', ['propertyMap'])
  },
  methods: {
    ...mapActions('propertyClient', ['loadPropertyMap']),
    getPrefectureImage: function (prefecture) {
      if (!this.propertyMap) return null

      return this.propertyMap[prefecture].image
    },
    getFukidashiClass: function (prefecture) {
      if (!this.propertyMap) {
        return 'fukidashi none'
      } else if (this.propertyMap[prefecture].property_count !== 0) {
        return 'fukidashi'
      } else {
        return 'fukidashi none'
      }
    },
    getAreaClass: function (prefecture) {
      if (!this.propertyMap) {
        return `area_${prefecture} disabled`
      } else if (this.propertyMap[prefecture].property_count !== 0) {
        return `area_${prefecture}`
      } else {
        return `area_${prefecture} disabled`
      }
    },
    getDisabledLayerStyle: function () {
      if (!this.propertyMap) return null

      const disabledPrefectures = []
      Object.keys(this.propertyMap).forEach(p => {
        if (this.propertyMap[p].property_count === 0) disabledPrefectures.push(p)
      })

      return {
        'background-image': disabledPrefectures.map(p => 'url(' + require(`@/assets/img/client/property-map/disabled_${p}2.png`) + ')').join(',')
      }
    },
    getHoveredLayerStyle: function () {
      if (!this.propertyMap || !this.activePrefecture) return null

      if (this.propertyMap[this.activePrefecture].property_count === 0) {
        return 'background-image: url(' + require(`@/assets/img/client/property-map/disabled_${this.activePrefecture}.png`) + ')'
      } else {
        return 'background-image: url(' + require(`@/assets/img/client/property-map/hover_${this.activePrefecture}.png`) + ')'
      }
    },
    getMapBoxStyle: function (prefecture) {
      // this.mapHoverCursor が存在する場合はマップ上のボックスを表示するので、こちらは処理しない
      if (!this.propertyMap || !this.activePrefecture || this.mapHoverCursor || this.activePrefecture !== prefecture) {
        return 'display: none'
      } else {
        return 'display: block'
      }
    },
    getMapAreaBoxStyle: function (prefecture) {
      if (!this.propertyMap || !this.activePrefecture || !this.mapHoverCursor || this.activePrefecture !== prefecture) {
        return 'display: none'
      } else {
        return {
          display: 'block',
          left: `${this.mapHoverCursor[0]}px`,
          top: `${this.mapHoverCursor[1]}px`
        }
      }
    },
    updateActivePrefecture: function (prefecture) {
      this.activePrefecture = prefecture
      if (prefecture === null) {
        this.mapHoverCursor = null
      }
    },
    hoverMapArea: function (event, prefecture) {
      this.activePrefecture = prefecture
      this.mapHoverCursor = [event.clientX, event.clientY]
    }
  },
  components: {
    navbar,
    footerClient
  }
}
</script>
<style scoped>
/* ===== map ===== */
#map-wrap{
  color: #333;
  line-height: 1.8;
}
.map-wrapper {
  width: 95%;
  min-height: 740px;
  min-width: 1000px;
  padding: 2em 0;
  margin: 0 auto;
  position: relative;
}
.map-wrapper .map {
  position: relative;
  width: 539px;
  margin: 0 0 0 192px;
  text-align: center;
}
.map-wrapper .map area {
    width: 1100px;
    margin: 0 auto;
    position: relative;
}
.map-wrapper .map area.disabled {
  pointer-events: none;
}
.map-wrapper .map area.disabled:hover {
  cursor: inherit;
}
.map-wrapper .map .img-map {
  position: relative;
}
.map-wrapper .map .img-map .layer-hover, .map-wrapper .map .img-map .layer-disabled {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  content: "";
  background-color: transparent;
  background-repeat: no-repeat;
  pointer-events: none;
}
.map-wrapper .map .num-wrap {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}
.map-wrapper .map .num-wrap p {
  position: absolute;
  width: 38px;
  font-size: .9em;
  line-height: 1.5;
  text-align: center;
  pointer-events: none;
}
.map-wrapper .map .num-wrap p.disabled {
  opacity: 0;
}
.map-wrapper .map .num-wrap p.num-hokkaido {
  top: 58px;
  right: 51px;
}
.map-wrapper .map .num-wrap p.num-aomori {
  top: 145px;
  right: 86px;
}
.map-wrapper .map .num-wrap p.num-iwate {
  top: 178px;
  right: 65px;
}
.map-wrapper .map .num-wrap p.num-akita {
  top: 178px;
  right: 105px;
}
.map-wrapper .map .num-wrap p.num-miyagi {
  top: 220px;
  right: 67px;
}
.map-wrapper .map .num-wrap p.num-yamagata {
  top: 221px;
  right: 104px;
}
.map-wrapper .map .num-wrap p.num-fukushima {
  top: 258px;
  right: 85px;
}
.map-wrapper .map .num-wrap p.num-tokyo {
  top: 337px;
  right: 105px;
}
.map-wrapper .map .num-wrap p.num-saitama {
  top: 317px;
  right: 113px;
}
.map-wrapper .map .num-wrap p.num-kanagawa {
  top: 358px;
  right: 106px;
}
.map-wrapper .map .num-wrap p.num-chiba {
  top: 337px;
  right: 60px;
}
.map-wrapper .map .num-wrap p.num-ibaraki {
  top: 296px;
  right: 65px;
}
.map-wrapper .map .num-wrap p.num-tochigi {
  top: 291px;
  right: 97px;
}
.map-wrapper .map .num-wrap p.num-gunma {
  top: 291px;
  right: 129px;
}
.map-wrapper .map .num-wrap p.num-niigata {
  top: 257px;
  right: 141px;
}
.map-wrapper .map .num-wrap p.num-toyama {
  top: 288px;
  right: 192px;
}
.map-wrapper .map .num-wrap p.num-ishikawa {
  top: 288px;
  right: 225px;
}
.map-wrapper .map .num-wrap p.num-fukui {
  top: 316px;
  right: 237px;
}
.map-wrapper .map .num-wrap p.num-nagano {
  top: 318px;
  right: 165px;
}
.map-wrapper .map .num-wrap p.num-yamanashi {
  top: 343px;
  right: 139px;
}
.map-wrapper .map .num-wrap p.num-aichi {
  top: 373px;
  right: 193px;
}
.map-wrapper .map .num-wrap p.num-shizuoka {
  top: 373px;
  right: 155px;
}
.map-wrapper .map .num-wrap p.num-gifu {
  top: 333px;
  right: 200px;
}
.map-wrapper .map .num-wrap p.num-mie {
  top: 389px;
  right: 235px;
}
.map-wrapper .map .num-wrap p.num-osaka {
  top: 376px;
  right: 277px;
}
.map-wrapper .map .num-wrap p.num-hyogo {
  top: 346px;
  right: 312px;
}
.map-wrapper .map .num-wrap p.num-kyoto {
  top: 345px;
  right: 268px;
}
.map-wrapper .map .num-wrap p.num-shiga {
  top: 344px;
  right: 232px;
}
.map-wrapper .map .num-wrap p.num-nara {
  top: 382px;
  right: 256px;
}
.map-wrapper .map .num-wrap p.num-wakayama {
  top: 412px;
  right: 274px;
}
.map-wrapper .map .num-wrap p.num-okayama {
  top: 357px;
  right: 347px;
}
.map-wrapper .map .num-wrap p.num-hiroshima {
  top: 357px;
  right: 380px;
}
.map-wrapper .map .num-wrap p.num-tottori {
  top: 333px;
  right: 347px;
}
.map-wrapper .map .num-wrap p.num-shimane {
  top: 333px;
  right: 380px;
}
.map-wrapper .map .num-wrap p.num-yamaguchi {
  top: 348px;
  right: 412px;
}
.map-wrapper .map .num-wrap p.num-ehime {
  top: 409px;
  right: 384px;
}
.map-wrapper .map .num-wrap p.num-kagawa {
  top: 395px;
  right: 334px;
}
.map-wrapper .map .num-wrap p.num-kochi {
  top: 433px;
  right: 390px;
}
.map-wrapper .map .num-wrap p.num-tokushima {
  top: 415px;
  right: 335px;
}
.map-wrapper .map .num-wrap p.num-fukuoka {
  top: 378px;
  right: 471px;
}
.map-wrapper .map .num-wrap p.num-saga {
  top: 372px;
  right: 494px;
}
.map-wrapper .map .num-wrap p.num-nagasaki {
  top: 377px;
  right: 512px;
}
.map-wrapper .map .num-wrap p.num-oita {
  top: 385px;
  right: 448px;
}
.map-wrapper .map .num-wrap p.num-kumamoto {
  top: 417px;
  right: 474px;
}
.map-wrapper .map .num-wrap p.num-miyazaki {
  top: 424px;
  right: 449px;
}
.map-wrapper .map .num-wrap p.num-kagoshima {
  top: 446px;
  right: 479px;
}
.map-wrapper .map .num-wrap p.num-okinawa {
  top: 287px;
  right: 478px;
}
.map-wrapper .note {
  position: absolute;
  bottom: -110px;
  right: 0;
}
.map-wrapper .map-area {
  width: 1000px;
  margin: 0 auto;
  position: relative;
}
.map-wrapper .map-area ul {
  width: 250px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.map-wrapper .map-area ul li {
  width: 48%;
  margin: 0 1%;
}
.map-wrapper .map-area .area-wrap {
  position: relative;
  z-index: 10;
}
.map-wrapper .map-area .area-wrap a:hover{
  opacity: 1;
}
.map-wrapper .map-area .area1 {
  position: absolute;
  top: 20px;
  right: 0px;
  z-index: 100;
}
.map-wrapper .map-area .area1 button {
  background: #b3de53;
}
.map-wrapper .map-area .area2 {
  position: absolute;
  top: 80px;
  right: 0px;
  z-index: 90;
}
.map-wrapper .map-area .area2 button {
  background: #e6f436;
}
.map-wrapper .map-area .area3 {
  position: absolute;
  top: 230px;
  right: 0px;
  z-index: 80;
}
.map-wrapper .map-area .area3 button {
  background: #e58a8a;
}
.map-wrapper .map-area .area4 {
  position: absolute;
  top: 0px;
  left: 400px;
}
.map-wrapper .map-area .area4 ul {
  margin: 0 1%;
  width: 120px;
  display: block;
}
.map-wrapper .map-area .area4 ul li {
  width: 100%;
}
.map-wrapper .map-area .area4 ul li button {
  background: #9999c9;
  color: #fff;
}
.map-wrapper .map-area .area5 {
  position: absolute;
  top: 430px;
  right: 125px;
  z-index: 70;
}
.map-wrapper .map-area .area5 button {
  background: #72c5e5;
}
.map-wrapper .map-area .area6 {
  position: absolute;
  top: 0px;
  left: 110px;
  display: flex;
  flex-flow: row-reverse;
}
.map-wrapper .map-area .area6 ul {
  margin: 0 10px;
  width: 120px;
  display: block;
}
.map-wrapper .map-area .area6 ul li {
  width: 100%;
}
.map-wrapper .map-area .area6 ul.block-1 button {
  background: #feb32b;
  color: #fff;
}
.map-wrapper .map-area .area6 ul.block-2 button {
  background: #99d47f;
}
.map-wrapper .map-area .area7 {
  position: absolute;
  top: 530px;
  left: 460px;
}
.map-wrapper .map-area .area7 button {
  background: #c999b9;
}
.map-wrapper .map-area .area8 {
  position: absolute;
  top: 310px;
  left: 0px;
}
.map-wrapper .map-area .area8 ul {
  width: 120px;
  display: block;
}
.map-wrapper .map-area .area8 ul li {
  width: 100%;
}
.map-wrapper .map-area .area8 button {
  background: #689fca;
  color: #fff;
}
.map-wrapper .map-area .area9 {
  position: absolute;
  top: 250px;
  left: 0px;
}
.map-wrapper .map-area .area9 button {
  background: #00b286;
  color: #fff;
}

.fukidashi {
  margin-bottom: 0.5em;
  position: relative;
}
.fukidashi span button {
  width: 100%;
  padding: 0.3em 0;
  font-size: 1em;
  font-weight: normal;
  line-height: normal;
  display: block;
  border: none;
  border-radius: 5px;
  text-align: center;
  cursor: pointer;
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all  0.5s ease;
}
.fukidashi span button:hover {
  background: #ff6600 !important;
  text-decoration: none;
}
.fukidashi .box {
  width: 200px;
  display: none;
  position: absolute;
  left: 0%;
  padding: 10px 14px;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
  z-index: 9999;
  overflow: auto;
}
.fukidashi .box p.ttl {
  margin-bottom: 0.5em;
  font-size: 1em;
  line-height: 1em;
}
.fukidashi .box p {
  font-size: 0.9em;
  line-height: 1.2em;
}
.fukidashi .box p img {
  width: 180px;
  height: 90px;
  object-fit: cover;
}

.none span button {
  transition: none;
  position: relative;
  color: #808080;
  pointer-events: none;
}
.none span button:before {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 5px;
  content: "";
  background-color: rgba(255, 255, 255, 0.5);
  z-index: 0;
}
.none:hover span button {
  background: #d9d9d9 !important;
}
.none:hover span button:before {
  display: none;
}

.p_box {
  width: 200px;
  display: none;
  position: fixed;
  padding: 10px 14px;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
  z-index: 9999;
  overflow: auto;
  text-align: left;
}
.p_box p.ttl {
  margin-bottom: 0.5em;
  font-size: 1em;
  line-height: 1em;
}
.p_box p {
  font-size: 0.9em;
  line-height: 1.2em;
}
.p_box p img {
  width: 180px;
  height: 90px;
  object-fit: cover;
}

.none-fukidashi {
  display: none !important;
}
@media screen and (max-width: 1020px) {
  button {
    -webkit-appearance: none !important;
    appearance: none !important;
  }

  .map {
    display: none;
  }

  .map-wrapper {
    width: 100%;
    min-width: 100%;
    padding: 0.5em 0 10em 0;
  }
  .map-wrapper .map-area {
    width: 100%;
  }
  .map-wrapper .map-area ul {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .map-wrapper .map-area ul li {
    width: 31.3%;
  }
  .map-wrapper .map-area .area1 {
    position: static;
  }
  .map-wrapper .map-area .area2 {
    position: static;
  }
  .map-wrapper .map-area .area3 {
    position: static;
  }
  .map-wrapper .map-area .area5 {
    position: static;
  }
  .map-wrapper .map-area .area4 {
    position: static;
  }
  .map-wrapper .map-area .area4 ul {
    width: 100%;
    margin: 0;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .map-wrapper .map-area .area4 ul li {
    width: 31.3%;
  }
  .map-wrapper .map-area .area6 {
    position: static;
    display: block;
  }
  .map-wrapper .map-area .area6 ul {
    width: 100%;
    margin: 0;
  }
  .map-wrapper .map-area .area6 ul li {
    width: 31.3%;
  }
  .map-wrapper .map-area .area6 ul.block-1 {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .map-wrapper .map-area .area6 ul.block-2 {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .map-wrapper .map-area .area7 {
    position: static;
  }
  .map-wrapper .map-area .area8 {
    position: static;
  }
  .map-wrapper .map-area .area8 ul {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .map-wrapper .map-area .area8 ul li {
    width: 31.3%;
  }
  .map-wrapper .map-area .area9 {
    position: static;
  }

  .fukidashi .box {
    width: 100%;
    left: 0%;
    padding: 10px;
  }
  .fukidashi .box p {
    font-size: 0.8em;
    line-height: 1.1em;
  }
  .fukidashi .box p img {
    width: 140px;
    height: 60px;
    object-fit: cover;
  }
  .fukidashi .box.current {
    display: block;
  }

  .note {
    display: none;
  }
}
</style>
